import { useEffect } from "react";

/**
 * 动态设置页面标题与描述，用于分类页 / 详情页 / 搜索页 / 关于页各自独立的 TDK。
 */
export function useDocumentTitle(title: string, description?: string) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("name", "description");
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", description);
    }
  }, [title, description]);
}